var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAttachmentPlaceholderFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 50,
    viewBox: "0 0 79 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0.5H73C76.0376 0.5 78.5 2.96243 78.5 6V44C78.5 47.0376 76.0376 49.5 73 49.5H6C2.96243 49.5 0.5 47.0376 0.5 44V6C0.5 2.96243 2.96243 0.5 6 0.5Z",
    fill: "white",
    stroke: "#ECEFF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9918 39H32.1775V36.2195H34.8973V35.2255H32.1775V33.4485H35.185V32.4545H30.9918V39ZM37.451 32.4545H36.2652V39H37.451V32.4545ZM38.735 39H42.8035V38.006H39.9207V32.4545H38.735V39ZM43.8326 39H48.1153V38.006H45.0183V36.2195H47.8692V35.2255H45.0183V33.4485H48.0897V32.4545H43.8326V39Z",
    fill: "#383F43"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3333 11.9048H36C35.6463 11.9048 35.3072 12.0453 35.0572 12.2953C34.8071 12.5454 34.6666 12.8845 34.6666 13.2381V23.9048C34.6666 24.2584 34.8071 24.5975 35.0572 24.8476C35.3072 25.0976 35.6463 25.2381 36 25.2381H44C44.3536 25.2381 44.6927 25.0976 44.9428 24.8476C45.1928 24.5975 45.3333 24.2584 45.3333 23.9048V15.9048L41.3333 11.9048Z",
    stroke: "#383F43",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3333 11.9048V15.9048H45.3333",
    stroke: "#383F43",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6666 19.2383H37.3333",
    stroke: "#383F43",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6666 21.9048H37.3333",
    stroke: "#383F43",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6666 16.5713H37.9999H37.3333",
    stroke: "#383F43",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAttachmentPlaceholderFilled);
export default __webpack_public_path__ + "static/media/icon-attachment-placeholder-filled.31b62117764c50f605c8ab31c73deb85.svg";
export { ForwardRef as ReactComponent };